/* Zyara FR — tiroir « Kaching Cart » reproduit sans l'app.
   Balisage d'origine (snippets/tx-kaching-cart.liquid) ; rendu depuis /cart.js et /products/<handle>.js.
   + ajout automatique de la « Livraison premium offerte » (app vex sur la source). */
(function () {
  'use strict';
  var root = document.querySelector('kaching-cart');
  var cfgEl = document.getElementById('tx-kc-config');
  if (!root || !cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var nativeFetch = window.fetch.bind(window);
  var wrap = root.querySelector('.kaching-cart');
  var inner = root.querySelector('kaching-cart-drawer');
  var contents = root.querySelector('.kaching-cart__contents');
  var footer = root.querySelector('.kaching-cart__footer');
  var box = root.querySelector('[data-tx-kc-items]');
  var ann = root.querySelector('.kaching-cart__announcement-bar');
  var annMod = ann && ann.closest('.kaching-cart__module');
  var tplItem = document.getElementById('tx-kc-item');
  var tplEmpty = document.getElementById('tx-kc-empty');
  var emptyEl = null, busy = false, pcache = {};

  function money(c) {
    var s = (Math.round(c) / 100).toFixed(2).split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + s[1] + ' €';
  }
  function moneyShort(c) { return c % 100 ? money(c) : String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €'; }
  function product(h) {
    if (!pcache[h]) pcache[h] = nativeFetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    return pcache[h];
  }
  function api(url, body) {
    return nativeFetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined }).then(function (r) { return r.json(); });
  }
  function open() {
    wrap.classList.add('active');
    document.documentElement.classList.add('kaching-cart-open');
  }
  function close() {
    wrap.classList.remove('active');
    document.documentElement.classList.remove('kaching-cart-open');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet');
  }
  var closeBtn = root.querySelector('.kaching-cart__close'), overlay = root.querySelector('.kaching-cart__overlay');
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function ensureShipping(cart) {
    if (!CFG.shipping_variant) return Promise.resolve(cart);
    var ship = cart.items.filter(function (i) { return i.variant_id === CFG.shipping_variant; })[0];
    var paid = cart.items.filter(function (i) { return i.variant_id !== CFG.shipping_variant; });
    if (paid.length && !ship) return api('/cart/add.js', { items: [{ id: CFG.shipping_variant, quantity: 1 }] }).then(function () { return api('/cart.js'); });
    if (!paid.length && ship) return api('/cart/change.js', { id: ship.key, quantity: 0 });
    if (ship && ship.quantity > 1) return api('/cart/change.js', { id: ship.key, quantity: 1 });
    return Promise.resolve(cart);
  }

  function line(item, prod) {
    var n = tplItem.content.firstElementChild.cloneNode(true);
    var el = n.querySelector('.kaching-cart-item');
    el.setAttribute('data-line-key', item.key);
    el.setAttribute('data-product-handle', item.handle);
    el.setAttribute('data-product-id', item.product_id);
    var url = '/products/' + item.handle + '?variant=' + item.variant_id;
    [].forEach.call(n.querySelectorAll('a'), function (a) { a.href = url; });
    var img = n.querySelector('.kaching-cart-item__image');
    if (img) { img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : ''; img.alt = item.product_title; }
    var t = n.querySelector('.kaching-cart-item__title'); if (t) t.textContent = item.product_title;
    var sel = n.querySelector('.kaching-cart-item__variant-selectors'), names = n.querySelector('.kaching-cart-item__option-names');
    var hasOpts = prod && prod.variants.length > 1;
    if (!hasOpts) { if (sel) sel.remove(); if (names) names.remove(); }
    else {
      if (names) names.textContent = prod.options.map(function (o) { return o.name; }).join(' / ') + ':';
      var row = sel.querySelector('.kaching-variant-selectors-row__selectors'); row.innerHTML = '';
      prod.options.forEach(function (o, k) {
        var s = document.createElement('select');
        s.className = 'kaching-cart-selector'; s.name = o.name; s.setAttribute('data-option-name', o.name); s.setAttribute('aria-label', o.name); s.style.cursor = 'pointer';
        o.values.forEach(function (v, vi) {
          var op = document.createElement('option'); op.value = v; op.textContent = v; op.setAttribute('data-option-value-index', vi);
          if (item.options_with_values && item.options_with_values[k] && item.options_with_values[k].value === v) op.selected = true;
          s.appendChild(op);
        });
        s.addEventListener('change', function () {
          var vals = [].map.call(row.querySelectorAll('select'), function (x) { return x.value; });
          var nv = prod.variants.filter(function (v) { return v.options.join('|') === vals.join('|'); })[0];
          if (!nv) return;
          act(api('/cart/change.js', { id: item.key, quantity: 0 }).then(function () { return api('/cart/add.js', { items: [{ id: nv.id, quantity: item.quantity }] }); }));
        });
        row.appendChild(s);
      });
    }
    var q = n.querySelector('.kaching-cart-item__quantity-input');
    var qc = n.querySelector('.kaching-cart-item__quantity-controls');
    if (item.variant_id === CFG.shipping_variant) { if (qc) qc.remove(); }
    else if (q) {
      q.value = item.quantity;
      n.querySelector('.kaching-cart-item__quantity-btn--decrement').addEventListener('click', function () { act(api('/cart/change.js', { id: item.key, quantity: Math.max(0, item.quantity - 1) })); });
      n.querySelector('.kaching-cart-item__quantity-btn--increment').addEventListener('click', function () { act(api('/cart/change.js', { id: item.key, quantity: item.quantity + 1 })); });
      q.addEventListener('change', function () { act(api('/cart/change.js', { id: item.key, quantity: Math.max(0, parseInt(q.value, 10) || 0) })); });
    }
    var variant = prod && prod.variants.filter(function (v) { return v.id === item.variant_id; })[0];
    var compare = variant && variant.compare_at_price > item.original_price ? variant.compare_at_price : item.original_price;
    var old = compare * item.quantity, fin = item.final_line_price;
    var so = n.querySelector('.kaching-cart-item__total-old'), sf = n.querySelector('.kaching-cart-item__total-final');
    if (so) { so.textContent = money(old); so.style.display = old > fin ? '' : 'none'; }
    if (sf) sf.textContent = fin === 0 ? 'OFFERT' : money(fin);
    var badge = n.querySelector('.kaching-cart__badge');
    if (badge) {
      if (old > fin) badge.querySelector('span').textContent = 'Vous économisez ' + moneyShort(old - fin);
      else badge.remove();
    }
    var rm = n.querySelector('.kaching-cart-item__remove-btn');
    if (rm) {
      rm.setAttribute('aria-label', 'Retirer ' + item.product_title + ' du panier');
      rm.addEventListener('click', function () { act(api('/cart/change.js', { id: item.key, quantity: 0 })); });
    }
    return { node: n, saved: Math.max(0, old - fin) };
  }

  function render(cart) {
    var empty = !cart.items.length;
    if (empty) {
      if (!emptyEl) { emptyEl = tplEmpty.content.firstElementChild.cloneNode(true); contents.parentNode.insertBefore(emptyEl, contents); }
      emptyEl.style.display = ''; contents.style.display = 'none'; footer.style.display = 'none';
      inner.classList.add('kaching-cart__inner--empty');
      return Promise.resolve();
    }
    if (emptyEl) emptyEl.style.display = 'none';
    contents.style.display = ''; footer.style.display = ''; inner.classList.remove('kaching-cart__inner--empty');
    if (annMod) annMod.style.display = '';
    // la livraison offerte en tete, comme sur la source
    var items = cart.items.slice().sort(function (a, b) { return (b.variant_id === CFG.shipping_variant) - (a.variant_id === CFG.shipping_variant); });
    return Promise.all(items.map(function (i) { return product(i.handle); })).then(function (prods) {
      box.innerHTML = ''; var saved = 0;
      items.forEach(function (it, k) { var l = line(it, prods[k]); saved += l.saved; box.appendChild(l.node); });
      var d = root.querySelector('.kaching-cart__cart-discounts');
      var da = root.querySelector('.kaching-cart__cart-discounts-amount');
      if (da) da.textContent = '-' + money(saved);
      if (d) d.style.display = saved > 0 ? '' : 'none';
      var st = root.querySelector('.kaching-cart__subtotal span'); if (st) st.textContent = money(cart.total_price);
    });
  }

  function bubble(cart) {
    var b = document.getElementById('cart-icon-bubble'); if (!b) return;
    var c = b.querySelector('.cart-count-bubble');
    if (!cart.item_count) { if (c) c.remove(); return; }
    if (!c) { c = document.createElement('div'); c.className = 'cart-count-bubble'; c.innerHTML = '<span aria-hidden="true"></span>'; b.appendChild(c); }
    c.querySelector('span').textContent = cart.item_count < 100 ? cart.item_count : '';
  }

  function refresh(openAfter) {
    return api('/cart.js').then(ensureShipping).then(function (c) { return c.items ? c : api('/cart.js'); })
      .then(function (cart) { bubble(cart); return render(cart).then(function () { if (openAfter) open(); return cart; }); });
  }
  function act(p) {
    if (busy) return; busy = true; wrap.classList.add('kaching-cart--loading');
    p.then(function () { return refresh(false); }).finally(function () { busy = false; wrap.classList.remove('kaching-cart--loading'); });
  }
  var co = root.querySelector('.kaching-cart__checkout-button');
  if (co) co.addEventListener('click', function (e) { e.preventDefault(); location.href = '/checkout'; });

  // icone panier et liens /cart -> tiroir
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]');
    if (!a || root.contains(a)) return;
    e.preventDefault(); e.stopPropagation(); refresh(true);
  }, true);

  // toute ecriture panier du theme (fetch ou XHR) -> rafraichir ; un ajout ouvre le tiroir
  function hook(url, ok) {
    if (!/\/cart\/(add|change|update|clear)(\.js)?/.test(url || '')) return;
    if (ok) setTimeout(function () { refresh(/\/cart\/add/.test(url)); }, 60);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    return nativeFetch(input, init).then(function (r) { hook(url, r.ok); return r; });
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__txu = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this; x.addEventListener('load', function () { hook(x.__txu, x.status < 400); });
    return xs.apply(this, arguments);
  };
  window.txCart = { open: open, close: close, refresh: refresh };
  refresh(false);
})();
